import { Role } from "types/user";

/**
 * Whether the /inscription/particulier flow route should be available.
 * Mirrors previous guards: unauthenticated, or already provider without client role.
 */
export function canRegisterAsClient(roles: string[] | null | undefined): boolean {
    if (roles == null) {
        return true;
    }
    if (roles.length === 0) {
        return false;
    }
    return roles.includes(Role.PROVIDER) && !roles.includes(Role.CLIENT);
}

/**
 * Whether the /inscription/prestataire flow route should be available.
 * Mirrors previous guards: unauthenticated, or already client without provider role.
 */
export function canRegisterAsProvider(roles: string[] | null | undefined): boolean {
    if (roles == null) {
        return true;
    }
    if (roles.length === 0) {
        return false;
    }
    return roles.includes(Role.CLIENT) && !roles.includes(Role.PROVIDER);
}
